
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import moment from "moment";
import util from './../../utils/utils';
import intl from 'react-intl-universal';

import { resetData } from './features'
export const GET_PRODUCT_DETAIL = "GET_PRODUCT_DETAIL";
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const GET_ALL_CATEGORY = "GET_ALL_CATEGORY";
export const GET_VERSION_LIST = "GET_VERSION_LIST";
export const SET_ADMIN = "SET_ADMIN";


const IOT_FETURE_DOMAIN = '/iot/feature';


moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

// 设置产品详情
export function setProductDetail(data) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_PRODUCT_DETAIL,
      productDetail: data,
    });
  }
}

// 获取产品详情接口，暂时无此接口，使用列表接口代替
export function getProductBaseInfo(params = {}, callback) {
  return (dispatch, getState) => {
    const { pid = '' } = params;

    if (!pid) {
      return;
    }

    const url = `/iot/config/api/iot/support/product/info?productId=${pid}`;
    const fetchData = new FetchData(url, {
      method: "GET",
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code === '200') {
          const { data } = res;
          if (data) {
            dispatch(setProductDetail(data))
          } else {
            // 未查找到详情时返回产品列表
            window.location.href = '/home/product';
          }
          callback && callback();
        }
      })
      .catch(e => { });
  };
}
// 获取产品列表
export function getProductList(params = {}, callback) {
  return (dispatch, getState) => {
    const { pid = '', current = 1, pageSize = 10 } = params;
    const defaultParam = {
      pageStart: parseInt(current) - 1,
      pageSize: parseInt(pageSize),
    };
    if (pid) {
      defaultParam['keyword'] = pid;
    }
    dispatch(updateLoadingStatus(true));
    // const url = '/iot/config/api/iot/support/product/page';
    const url = '/iot/config/api/iot/support/productV3/page';
    const fetchData = new FetchData(url, {
      method: "POST",
      body: defaultParam,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        dispatch(updateLoadingStatus(false));
        if (res.code === '200') {
          const {
            data = [],
            page = {
              page: 0,
              size: 10,
              total: 0
            }
          } = res;
          const {
            oprType,
            productId,
          } = params;
          dispatch({
            type: GET_PRODUCT_LIST,
            productList: data,
            total: page.total,
            current,
            pageSize,
          });
          // 创建产品后跳转到产品详情页面，并且打开添加功能点弹窗
          if (oprType === 'ADD') {
            const { categoryList } = getState().product;
            data.forEach(item => {
              if (item.productId === productId) {
                let pic = '';
                let categoryLabel = ''
                categoryList.map(v => {
                  const { children = [] } = v;
                  if (Array.isArray(children)) {
                    children.map(k => {
                      if (k.categoryId == item.categoryId) {
                        pic = k.displayUrl;
                        categoryLabel = k.categoryLabel;
                      }
                    })
                  }
                })
                item.categoryPic = pic;
                util.setStorage("ezviz_iot_current_product_info", JSON.stringify(item));
                // 添加产品后，重置功能点相关的数据
                dispatch(resetData())
              }
            })
          }
          callback && callback();
        }
      })
      .catch(e => {
        dispatch(updateLoadingStatus(false));
      });
  };
}
//获取固件升级产品列表
export function getOtaProductList(params = {}, callback) {
  return (dispatch, getState) => {
    const { pid = '', current = 1, pageSize = 10 } = params;
    const defaultParam = {
      pageStart: parseInt(current) - 1,
      pageSize: parseInt(pageSize),
    };
    if (pid) {
      defaultParam['keyword'] = pid;
    }
    dispatch(updateLoadingStatus(true));
    // const url = '/iot/config/api/iot/support/product/page';
    const url = '/iot/config/api/iot/support/product/ota/page';
    const fetchData = new FetchData(url, {
      method: "POST",
      body: defaultParam,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        dispatch(updateLoadingStatus(false));
        if (res.code === '200') {
          const {
            data = [],
            page = {
              page: 0,
              size: 10,
              total: 0
            }
          } = res;
          const {
            oprType,
            productId,
          } = params;
          dispatch({
            type: GET_PRODUCT_LIST,
            productList: data,
            total: page.total,
            current,
            pageSize,
          });
          callback && callback();
        }
      })
      .catch(e => {
        dispatch(updateLoadingStatus(false));
      });
  };
}

export function updateProduct(values, oprType, callback, failback) {
  return (dispatch, getState) => {
    let req = values;
    let url = '/iot/config/api/iot/support/product/create';
    if (oprType === 'ADD' || oprType === 'COPY') {
      req['productType'] = '0';
      // 2021-09-15 增加复制产品功能
      if (oprType === 'COPY') {
        url = '/iot/config/api/iot/support/product/copy';
        url += `?copyPid=${values.copyPid}`;
      }
      // 2021-07-26 增加可选参数 productId
      // 可以支持自定义productId
      if (values.productId) {
        if (url.indexOf('?') > -1) {
          url += `&productId=${values.productId}`;
        } else {
          url += `?productId=${values.productId}`;
        }
      }

    } else {
      req = {
        pid: values.productId,
        productName: values.productName,
        productPic: values.productPic,
        apPrefix: values.apPrefix,
        productModel: values.productModel,
        remark: values.remark,
      }
      url = '/iot/config/api/iot/support/product/update';
    }

    message.loading("loading...", 0);
    const fetchData = new FetchData(url, {
      method: 'POST',
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        message.destroy();
        if (data.code === '200') {
          message.success(intl.get('commmon.operate.success'));
          if (oprType === 'EDIT') {
            dispatch(getProductBaseInfo({ pid: values.productId }))
          }
          dispatch(getProductList({
            oprType,
            productId: data.data,
          }, () => {
            callback && callback({ productId: data.data });
          }))
          // 2021-09-26 如果是编辑或复制，调用一次发布接口
          // 后续服务端修改优化后，不需要再调用发布接口
          if (oprType === 'EDIT') {
            dispatch(publishProduct({ productId: req.pid, }))
          } else if (oprType === 'COPY') {
            dispatch(publishProduct({ productId: data.data, }))
          }
        } else {
          message.error(data.msg || intl.get('commmon.operate.retry'));
          failback && failback()
        }
      })
      .catch(e => {
        message.destroy()
        failback && failback()
      });
  };
}

// 设置功能点或配置APP面板后需要调用一次发布接口
export function publishProduct(data, callback, failback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { firmwareUpgradeCode = 'V1.0.0' } = productDetail;
    const { productId, publishStatus } = data
    const url = `/iot/config/api/iot/support/product/release`;
    const query = {
      pId: productId,
      firmwareUpgradeCode,
      // publishStatus: publishStatus || 0,
      publishStatus: 'unpublished',
    }

    const fetchData = new FetchData(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: "POST",
      query,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          if (publishStatus) {
            message.success(intl.get('home.product.firmwareUpgradeDetail.releaseSuccess'));
          }
          //不需要调获取产品详情，productdetail hook写法监听，会重复刷新
          // dispatch(getProductBaseInfo({ pid: productId }));
          callback && callback();
        } else {
          if (publishStatus) {
            message.error(data.msg || intl.get('commmon.operate.retry'));
          }
          failback && failback()
        }
      })
      .catch(e => {
        if (publishStatus) {
          message.error(intl.get('commmon.operate.retry'));
        }
        failback && failback()
      });
  };
}

export function deleteProduct(id, callback) {
  return (dispatch, getState) => {
    message.loading("loading...", 0);
    const fetchData = new FetchData(`/iot/config/api/iot/support/product/delete`, {
      method: "POST",
      body: {
        pid: id
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        message.destroy()
        if (data.code == 200) {
          callback();
          message.success(intl.get('commmon.operate.deleteSuccess'));
        } else {
          message.error(data.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.destroy()
        message.error(intl.get('commmon.operate.deleteFail'));
      });
  };
}

export function getAllMainCategoryList(param) {
  return (dispatch, getState) => {
    const defaultParam = {
      productLine: 'ys',
      offset: 0,
      limit: 200,
    }
    const req = Object.assign({}, defaultParam, param);
    const fetchData = new FetchData(`/iot/config/api/iot/support/product/category/list`, {
      method: 'GET',
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        const categoryList = res.data ? (res.data || []) : [];
        // 20210705 照明排第一个
        // 需求来源：张航
        const tempCategoryList = [];
        categoryList.forEach(item => {
          if (item.mainCategory === "lighting") {
            tempCategoryList.unshift(item)
          } else {
            tempCategoryList.push(item)
          }
        })

        // 20210918 将所有小类信息按类目保存到对象中，方便产品信息按类目获取品类信息
        const categoryInfo = {};
        categoryList.map(v => {
          const { subMap = {} } = v;
          if (subMap) {
            Object.keys(subMap).forEach(subTagName => {
              if (subMap[subTagName]) {
                subMap[subTagName].forEach(subCategoryObj => {
                  categoryInfo[subCategoryObj.category] = subCategoryObj;
                  const parsedLabel = util.parseJSON(subCategoryObj.label);
                  categoryInfo[subCategoryObj.category].displayLabel = (parsedLabel && parsedLabel.label) ? parsedLabel.label : subCategoryObj.label;
                })
              }
            })
          }
        })

        dispatch({
          type: GET_ALL_CATEGORY,
          categoryList: tempCategoryList,
          categoryInfo,
        });
        util.setStorage('ezviz_iot_categoryList', JSON.stringify(tempCategoryList));
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}


export function supportAuth(param = {}) {
  return (dispatch, getState) => {
    const {
      biz = 'admin',
    } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/auth`, {
      method: 'GET',
      body: { biz },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: SET_ADMIN,
          biz,
          allowed: res.data == 'allowed',
        });
      } else {

      }
    }).catch(e => {

    })
  };
}
